import React, {RefObject} from "react";
import IPresenter from "../../../../../model/interface/dataStorage/IPresenter";
import {Button, Form, FormInstance, Input, InputNumber, Modal, Row, Select} from "antd";
import _ from "underscore"
import PresenterBuilder, {IPresenterType} from "../../../../../views/dataStorage/PresenterBuilder";
import IContentType from "../../../../../model/interface/dataStorage/IContentType";
import {connect, RootStateOrAny} from "react-redux";
import selectors from "../../../../../redux/selectors";
import IRepositoryService from "../../../../../model/interface/IRepositoryService";
import ContentTypePresenterMentions from "./ContentTypePresenterMentions";
import {update} from "../../../../../redux/actions/Setup";
import {ISetupState} from "../../../../../redux/reducers/Setup";
import PresentersService from "../../../../../model/service/dataStorage/PresentersService";
import TranslationInput from "../../../../shared/input/TranslationInput";
import Utils from "../../../../../utils";
import FieldPicker from "../../../../shared/pickers/FieldPicker";
import LocaleText from "../../../settings/dictionary/LocaleText";
import IPresenterRelation from "../../../../../model/interface/dataStorage/presenter/IPresenterRelation";
import {CloseOutlined} from "@ant-design/icons";
import FilterTreeBuilder from "../../../view/settings/customFilters/FilterTreeBuilder";
import {RouteComponentProps, withRouter} from "react-router-dom";
import DragSortList from "../../../../shared/list/DragsortList";
import arrayMove from "array-move";

interface IProps extends RouteComponentProps {
    resource?: IPresenter
    contentType: IContentType
    onSubmit: (values?: IPresenter) => void
    findServiceByClassName: (name: string) => IRepositoryService
    modal?: boolean,
    update: (changes: any) => void,
    saveMode: 'update-state' | 'save' | 'none',
    contentTypes: IContentType[]
}

interface IState {
    type?: IPresenterType,
    saving?: boolean
    relations: IPresenterRelation[]
}

class ContentTypePresentersForm extends React.Component<IProps, IState> {

    formRef: RefObject<FormInstance> = React.createRef()

    defaultProps = {
        resource: {
            uuid: Utils.uuid(),
            type: 'label',
            name: '',
            label: '',
            options: {},
        }
    }

    constructor(props: IProps) {
        super(props);
        this.state = {
            relations: props.resource?.childRelations || []
        }
    }

    componentDidMount() {
        this.setType(this.props.resource?.type || 'label')
    }

    setType = (type?: string) => {
        this.setState({type: _.findWhere(PresenterBuilder.getTypes(), {type})})
    }

    buildTypeOptions() {
        return PresenterBuilder.getTypes().map(type => ({
            label: type.label,
            value: type.type
        }))
    }

    buildFieldOptions() {
        return this.props.contentType.fields
            .map(field => ({
                label: field.label,
                value: field.name
            }))
    }

    addRelation = (presenter: string) => {
        this.setState(state => ({
            relations: [...state.relations, {
                uuid: Utils.uuid(),
                child: presenter,
                conditions: {},
                weight: state.relations.length + 1
            }]
        }), () => this.formRef.current?.setFieldsValue({_temp: undefined}) || {})
    }

    onSortEnd = ({oldIndex, newIndex}: { oldIndex: number, newIndex: number }): void => {
        const {relations} = this.state
        const sortedItems = arrayMove(relations, oldIndex, newIndex)
        oldIndex !== newIndex && this.setState({relations: sortedItems})
    }

    removeRelation = (uuid: string) => {
        this.setState(state => ({relations: [...state.relations.filter(f => f.uuid !== uuid)]}), () => this.formRef.current?.setFieldsValue({'childRelations': []}) || {})
    }

    renderTypeOptions(type: IPresenterType) {
        const {contentType, history, match, resource} = this.props
        const {relations} = this.state
        return type.options?.map(option => (
            <>
                {option.type === 'field' && (
                    <Form.Item name={['options', option.name]} label={option.label}>
                        <FieldPicker serviceClassName={contentType.fullClassName} output={'name'}/>
                    </Form.Item>
                )}
                {option.type === 'fields' && (
                    <Form.Item name={['options', option.name]} label={option.label}>
                        <Select options={this.buildFieldOptions()} mode={"multiple"} defaultValue={option.default}/>
                    </Form.Item>
                )}
                {option.type === 'string' && (
                    <Form.Item name={['options', option.name]} label={option.label}>
                        <Input defaultValue={option.default}/>
                    </Form.Item>
                )}
                {option.type === 'number' && (
                    <Form.Item name={['options', option.name]} label={option.label}>
                        <InputNumber defaultValue={option.default}/>
                    </Form.Item>
                )}
                {option.type === 'mentions' && (
                    <Form.Item name={['options', option.name]} label={option.label}>
                        <ContentTypePresenterMentions contentType={contentType}/>
                    </Form.Item>
                )}
                {option.type === 'relation' && (
                    <>
                        <Form.Item name={'_temp'}
                            label={<LocaleText code={'configuration.presenter.type.relation'} fallback={'Vazba'}/>}>
                            <Select defaultValue={option.default}
                                    onChange={presenter => this.addRelation(presenter)}>
                                {
                                    contentType.presenters.filter(p => relations.every(r => r.child !== p.uuid) && resource?.uuid !== p.uuid).map(p => (
                                        <Select.Option key={p.uuid} value={p.uuid || ''}><LocaleText
                                            code={p.label}/></Select.Option>))
                                }
                            </Select>
                        </Form.Item>
                        <DragSortList className={'mb-3'} useDragHandle={true} lockAxis={"y"} item={{
                            render: (relation: IPresenterRelation, index, handle) => {
                                const presenterObject = contentType.presenters.find(f => f.uuid === relation.child)
                                return presenterObject ? (
                                        <Row
                                            className={'border-bottom p-1 mb-2 shadow-sm'} align={'middle'}>
                                            <div className={'mr-2'}>{handle}</div>
                                            <Row wrap={false} className={'flex-grow-1'}>
                                                <Form.Item hidden={true} name={['childRelations',  index, 'child']} initialValue={presenterObject.uuid}>
                                                    <Input/>
                                                </Form.Item>
                                                <Form.Item initialValue={index + 1} hidden={true} name={['childRelations', index, 'weight']}>
                                                    <InputNumber/>
                                                </Form.Item>
                                                <Form.Item
                                                    label={<LocaleText code={presenterObject.label || presenterObject.name}/>}
                                                    className={'w-100 mb-0'} colon={false}
                                                    name={['childRelations', index, 'conditions']}>
                                                    <FilterTreeBuilder match={match} history={history} hideEmptyIcon={true}
                                                                       contentTypeFullClassName={contentType.fullClassName}/>
                                                </Form.Item>
                                                <Button type={'link'} danger={true} icon={<CloseOutlined/>}
                                                        onClick={() => this.removeRelation(relation.uuid)}/>
                                            </Row>
                                        </Row>
                                ) : <></>
                            }
                        }} children={relations} onSortEnd={this.onSortEnd}/>
                    </>

                )}
            </>
        ))
    }

    submit = () => {
        const {resource} = this.props
        this.formRef.current?.validateFields().then(values => {
            this.save({...resource, ...values, childRelations: values.childRelations})
        })
    }

    save(presenter: IPresenter) {
        const {update, onSubmit, contentType, saveMode, contentTypes} = this.props
        this.setState({saving: true});
        if (saveMode === 'update-state' || saveMode === 'save') {
            (presenter.id ? PresentersService.resourceRetrieve(contentType.uuid, presenter.id, presenter) :
                PresentersService.collectionCreate(contentType.uuid, presenter)).then(resource => {
                if (saveMode === 'update-state') {
                    update({
                        contentTypes: [...contentTypes.filter(c => c.uuid !== contentType.uuid), {
                            ...contentType,
                            presenters: [...contentType.presenters.filter(p => p.uuid !== resource.uuid), presenter]
                        }]
                    })
                }
                return onSubmit(presenter)
            })
        }
        onSubmit(presenter)
    }

    render() {
        const {resource, contentType, modal, onSubmit} = this.props
        const {type, saving} = this.state
        const formData = {type: 'label', ...resource}
        const form = <Form initialValues={formData} ref={this.formRef}
                           onFinish={values => this.save({...resource, ...values})}>
            <Form.Item name={"label"} label={"Titulek"}>
                <TranslationInput uuid={resource?.uuid || Utils.uuid()}
                                  code={'configuration.presenter.' + resource?.uuid}/>
            </Form.Item>
            <Form.Item name={"name"} label={"Název"} rules={[{required: true}, {pattern: /[a-z_]/}]}>
                <Input/>
            </Form.Item>
            <Form.Item name={"type"} label={"Typ"}>
                <Select options={this.buildTypeOptions()} onChange={this.setType}/>
            </Form.Item>
            {type && this.renderTypeOptions(type!)}
            <Form.Item name={"action"} label={"Akce"}
                       help={'Vykreslí jako odkaz a po jeho kliknutí se provede přiřazená akce'}>
                <Select allowClear>
                    {contentType.actions.map(action => (
                        <Select.Option value={action.uuid} key={action.uuid}>
                            {action.label}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            {!modal && <Button key="submit" type="primary" loading={saving} onClick={this.submit}>
                Uložit
            </Button>}
        </Form>
        return modal ?
            <Modal title={"Nastavení zobrazení"} visible={true} onCancel={() => onSubmit()}
                   destroyOnClose={true} closable={true} width={600}
                   footer={[
                       <Button key="submit" type="primary" loading={saving} onClick={this.submit}>
                           Uložit
                       </Button>
                   ]}>
                {form}
            </Modal> : form
    }
}


const mapStateToProps = (state: RootStateOrAny) => {
    const {contentTypes} = state.setup as ISetupState
    return {
        contentTypes,
        findServiceByClassName: (name: string) => selectors.services.findOneByFullClassName(state, name),
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        update: (changes: any) => dispatch(update(changes))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContentTypePresentersForm))